import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HomeSliderComponent } from './home-slider/home-slider.component';

interface AlternatingBlock {
  title: string;
  description: string;
  imageUrl: string;
  altText: string;
  linkUrl: string;
  services?: string[];
}

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    HomeSliderComponent
  ],
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent {
  blocks: AlternatingBlock[] = [
    {
      title: "Protection de bien mobilier et immobilier",
      description: "Surveillance et protection de biens mobiliers et immobiliers...",
      imageUrl: "assets/images/protection-block.png",
      altText: "Protection services",
      linkUrl: "/services/protection-de-bien-mobilier-et-immobilier"      
    },
    {
      title: "Contrôle des personnes et d'accès",
      description: "Surveillance et contrôle des personnes dans le cadre du maintien de...",
      imageUrl: "assets/images/controle-block.png",
      altText: "Contrôle",
      linkUrl: "/services/controle-des-personnes-et-dacces"
    },
    {
      title: "Sécurité événementielle",
      description: "ous organisez un événement...",
      imageUrl: "assets/images/security-block.png",
      altText: "Sécurité événementielle",
      linkUrl: "/services/securite-evenementielle"
    },

    {
      title: "Gardiennage chantier",
      description: "La surveillance de chantiers réalisée par Farco Security...",
      imageUrl: "assets/images/gardiennage-block.png",
      altText: "Gardiennage chantier",
      linkUrl: "/services/gardiennage-chantier"
    },
    {
      title: "Gardiennage industriel",
      description: "ous organisez un événement...",
      imageUrl: "assets/images/gardiennage2-block.png",
      altText: "Gardiennage industriel",
      linkUrl: "/services/gardiennage-industriel"
    },
    {
      title: "Accueil et gestion",
      description: "Des prestations de réception à la hauteur de votre standing...",
      imageUrl: "assets/images/gestion-block.png",
      altText: "Accueil et gestion",
      linkUrl: "/services/accueil-et-gestion"
    },
  ];
  
}